import { render, staticRenderFns } from "./MessagesHeader.vue?vue&type=template&id=b4626a32&scoped=true&"
import script from "./MessagesHeader.vue?vue&type=script&lang=js&"
export * from "./MessagesHeader.vue?vue&type=script&lang=js&"
import style0 from "./MessagesHeader.vue?vue&type=style&index=0&id=b4626a32&prod&lang=scss&scoped=true&"
import style1 from "./MessagesHeader.vue?vue&type=style&index=1&id=b4626a32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4626a32",
  null
  
)

export default component.exports